//pages

import {
  Dashboard,
  District,
  Batch,
  Pou,
  Setting,
  DistrictDetails,
  AddDistrict,
  EditDistrict,
  PouDetails,
  RequestRecieved,
  ChangePassword,
  IssuedBatch,
  RequestBatch,
  Requests,
  RetireBatch,
  IssuedbatchSecond,
  ReceiveInventory,
  NodeView,
} from "./pages";

import DetailsPage from "../../components/DetailsPage";
//routes

import { provinceRoutes, commonRoutes } from "../../Services/Routes/APP";

//admin routes export

export const provinceAdminRoutes = [
  {
    id: `province-120`,
    exact: false,
    path: provinceRoutes?.root,
    component: Dashboard,
  },
  {
    id: `province-121`,
    exact: false,
    path: provinceRoutes?.dashboard,
    component: Dashboard,
  },
  {
    id: `province-122`,
    exact: false,
    path: provinceRoutes?.requestRecieved,
    component: RequestRecieved,
  },
  {
    id: `province-124`,
    exact: false,
    path: provinceRoutes?.districts,
    component: District,
  },
  {
    id: `province-125`,
    exact: false,
    path: provinceRoutes?.detailsDistrict,
    component: DistrictDetails,
  },
  {
    id: `province-126`,
    exact: false,
    path: provinceRoutes?.addDistrict,
    component: AddDistrict,
  },
  {
    id: `province-127`,
    exact: false,
    path: provinceRoutes?.editDistrict,
    component: EditDistrict,
  },
  {
    id: `province-128`,
    exact: false,
    path: provinceRoutes?.pointOfUse,
    component: Pou,
  },
  {
    id: `province-129`,
    exact: false,
    path: provinceRoutes?.pouDetails,
    component: PouDetails,
  },
  {
    id: `province-130`,
    exact: false,
    path: provinceRoutes?.batch,
    component: Batch,
  },

  {
    id: `province-131`,
    exact: false,
    path: provinceRoutes?.setting,
    component: Setting,
  },
  {
    id: `province-132`,
    exact: false,
    path: provinceRoutes?.changePassword,
    component: ChangePassword,
  },
  {
    id: `province-133`,
    exact: false,
    path: provinceRoutes?.issuedBatch,
    component: IssuedBatch,
  },
  {
    id: `province-134`,
    exact: false,
    path: provinceRoutes?.request_inventory,
    component: RequestBatch,
  },
  {
    id: `province-135`,
    exact: false,
    path: provinceRoutes?.requests,
    component: Requests,
  },
  {
    id: `province-136`,
    exact: false,
    path: provinceRoutes?.retireBatch,
    component: RetireBatch,
  },
  {
    id: `province-136`,
    exact: false,
    path: provinceRoutes?.issuedBatchManually,
    component: IssuedbatchSecond,
  },
  {
    id: `province-137`,
    exact: false,
    path: provinceRoutes?.receiveInventory,
    component: ReceiveInventory,
  },
  {
    id: `province-137`,
    exact: false,
    path: commonRoutes?.batch?.details,
    component: DetailsPage,
  },
  {
    id: `province-138`,
    exact: false,
    path: commonRoutes?.request + commonRoutes?.details,
    component: DetailsPage,
  },
  {
    id: `province-139`,
    exact: false,
    path: commonRoutes?.nodeView,
    component: NodeView,
  },
  {
    id: `province-140`,
    exact: false,
    path: commonRoutes?.node?.details,
    component: DetailsPage,
  },
];
